import { render, staticRenderFns } from "./TicketItems.vue?vue&type=template&id=08e2663d&scoped=true&"
import script from "./TicketItems.vue?vue&type=script&lang=js&"
export * from "./TicketItems.vue?vue&type=script&lang=js&"
import style0 from "./TicketItems.vue?vue&type=style&index=0&id=08e2663d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e2663d",
  null
  
)

export default component.exports